<template>
	<div style="margin:0 40px;">
		<!-- <div style="height: 70px;width: 100%;line-height: 70px;color: #000;text-align: center;font-size: 20px;">{{this.dataTitle.njName}}作业信息</div>
    <div style="position: absolute;right: 40px;top: 5px;color: #000;font-size: 40px;cursor: pointer;" @click="dialogMapDetailClick">×</div> -->
		<div id="containers" class="Gogle-maps" style="margin-top: 50px;">
			<div style="width: 100%;background: rgba(10,22,55,0.5);position: absolute;z-index: 999;">
				<i class="blue-border-map"></i>
				<span class="textpad" style="    color: #fff;">{{this.dataTitle.njName}}作业信息</span>
				<div class="tableList1">
					<el-row :gutter="24">
						<el-col :span="4.5">
							<div class="items">
								<p>
									<span>监控编号:</span>
									<span>{{this.dataTitle.imei}}</span>
								</p>
								<p>
									<span>作业时间:</span>
									<span>{{this.dataTitle.operatTime}}</span>
								</p>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="items">
								<p>
									<span>机具类型:</span>
									<span>{{this.dataTitle.catThreeName}}</span>
								</p>
								<p>
									<span>时长:</span>
									<span>{{this.dataTitle.runTimeDay}}时</span>
								</p>
							</div>
						</el-col>
						<el-col :span="3.5">
							<div class="items">
								<p>
									<span>机具型号:</span>
									<span>{{this.dataTitle.productModel}}</span>
								</p>
								<p>
									<span>里程：</span>
									<span>{{this.dataTitle.mileageDay}}</span>
								</p>
							</div>
						</el-col>
						<el-col :span="5">
							<div class="items">
								<p>
									<span>出厂编号:</span>
									<span>{{this.dataTitle.factoryCode}}</span>
								</p>
								<p>
									<span>预计面积:</span>
									<span>{{this.dataTitle.operatArea}}亩</span>
								</p>
							</div>
						</el-col>
						<el-col :span="5">
							<div class="items">
								<p>
									<span>作业地区:</span>
									<span>{{this.dataTitle.workArea}}</span>
								</p>
							</div>
						</el-col>
					</el-row>
				</div>
				<!-- <div style="line-height: 30px"><div>
          <span class="textpad">监控编号：{{this.dataTitle.imei}}</span>
          <span class="textpad">机具类型：{{this.dataTitle.catThreeName}}</span>
          <span class="textpad">机具型号：{{this.dataTitle.product_model}}</span>
          <span class="textpad">出厂编号：{{this.dataTitle.factoryCode}}</span>
          </div>
          <span class="textpad">作业时间：{{this.dataTitle.operatTime}}</span>
          <span class="textpad">时长：{{this.dataTitle.runTimeDay}}</span>
          <span class="textpad">里程：{{this.dataTitle.mileageDay}}</span>
          <span class="textpad">预计面积：{{this.dataTitle.operatArea}}亩</span>
          <span class="textpad">作业地区：{{this.dataTitle.workArea}}</span>
          </div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import Gmap from '../../map/js/fzTianmap.js'
	import Http from '../../Serves/net-http.js'
	import Api from '../../Serves/net-api.js'
	import { mapState, mapActions, } from "vuex";
	import Vue from 'vue'
	export default {
		name: "TRecordItem",
		props: ['dialogMapDetailValue', 'collecTimeStrValue', 'dialogMapDetail', 'imei', 'njId', 'collectTime'],
		data() {
			return {
				center: {
					lng: 116.40,
					lat: 39.90
				},
				Gmap: new Gmap(),
				map: '',
				dataTitle: {
					operatTime: '', //作业时间
					runTimeDay: '', //时长
					mileageDay: '', //里程
					operatArea: '', //预计作业面积
					workArea: '', //作业区域
					imei: '', //设备编号
					startTime: '', //起始时间
					getkey: '',
				},
				startTime: '',
				dialogMapDetails: this.dialogMapDetail
			}
		},
		computed: {
			...mapState({
				time: state => state.time,
			})
		},
		watch: {
			imei(newValue, oldValue) {
				this.Record()
			}
		},
		mounted() {
			this.initMap()
			this.Record()
		},
		methods: {
			initMap() {
				this.Gmap.init('containers', 17)
			},
			dialogMapDetailClick() {
				this.$emit('dialogMapDetailFn', false)
				// this.dialogMapDetail = false
			},
			Record() { //轨迹
				// this.imei=this.dialogMapDetailValue?this.dialogMapDetailValue:this.dialogMapDetailValue
				// this.startTime=this.collecTimeStrValue?this.collecTimeStrValue:this.collecTimeStrValue
				//      this.imei=this.imei
				this.startTime = this.collectTime
				var url = Http.test + "/purchaseSubsidyMonitor/findTrack"
				var parmse = {
					imei: this.imei,
					startTime: this.startTime
				}
				Api.doPost(url, parmse, false, (res) => {
					//轨迹路线
					var List = res.result.list
					this.dataTitle = res.result
					for(var i = 0; i < List.length; i++) {
						this.Gmap.map.panTo(new T.LngLat(List[i].lng, List[i].lat), 17)
					}
					// this.Gmap.map.panTo(new T.LngLat(List[0].lng, List[0].lat), 14)
					this.Gmap.addMark(List)
					// //创建图片对象
					// var icon = new T.Icon({
					//   iconUrl:  require("../../map/img/move.png"),
					//   iconSize: new T.Point(19, 27),
					//   iconAnchor: new T.Point(30 , 25)
					// });
					// //向地图上添加自定义标注
					// // for (var i = 0; i < List.length; i++){
					//   var marker = new T.Marker(new T.LngLat(List[0].lng, List[0].lat), {icon: icon});
					// // }
					// this.Gmap.map.addOverLay(marker);
					/* this.newNode()*/
					//将路线记录显示出来
				}, function(err) {

				})
			},
			goBack() {
				var manage = JSON.parse(sessionStorage.getItem('manageParam'))
				sessionStorage.setItem('manageParams', JSON.stringify(manage))
				var manage1 = JSON.parse(sessionStorage.getItem('manageParam1'))
				sessionStorage.setItem('manageParams1', JSON.stringify(manage1))
				this.Info.Info.imei = this.$route.params.imei
				this.Info.Info.stat_time = this.$route.params.stat_time
				// this.Info.Info.imei=this.dialogMapDetailValue
				// this.Info.Info.stat_time=this.collecTimeStrValue
				this.$router.go(-1)
			},
			//横幅
			newNode() {
				var MyComponent = Vue.extend({
					template: '<div class="goole-block">' +
						'<i class="el-icon-back ret" @click="goBack(imei,stat_time)"></i>' +
						'<i class="blue-border-map"></i>' +
						'<p>{{titelName}}作业信息</p>' +
						'<div style="line-height: 30px">' + '<div>' +
						'<span class="textpad">监控编号：{{imei}}</span>' +
						'<span class="textpad">机具类型：{{catThreeName}}</span>' +
						'<span class="textpad">出厂编号：{{factoryCode}}</span>' +
						'</div>' +
						'<span class="textpad">作业时间：{{operatTime}}</span>' +
						'<span class="textpad">时长：{{runTimeDay}}</span>' +
						'<span class="textpad">里程：{{mileageDay}}</span>' +
						'<span class="textpad">预计面积：{{operatArea}}亩</span>' +
						'<span class="textpad">作业地区：{{workArea}}</span>' +
						'</div>' +
						'</div>',
					methods: {
						goBack: (imei, stat_time) => {
							this.Info.Info.imei = imei;
							this.Info.Info.stat_time = stat_time;
							this.$router.go(-1);
						}
					},
					data: function() {
						return {}
					},
					props: ['operatTime', 'runTimeDay', 'mileageDay', 'operatArea', 'workArea', 'imei', 'stat_time', 'titelName', 'factoryCode', 'catThreeName']
				})
				var component = new MyComponent({
					propsData: {
						operatTime: this.dataTitle.operatTime,
						runTimeDay: this.dataTitle.runTimeDay,
						mileageDay: this.dataTitle.mileageDay,
						operatArea: this.dataTitle.operatArea,
						workArea: this.dataTitle.workArea,
						imei: this.imei,
						stat_time: this.startTime,
						titelName: this.dataTitle.njName,
						catThreeName: this.dataTitle.catThreeName,
						factoryCode: this.dataTitle.factoryCode
					}
				}).$mount()
				setTimeout(function() {
					try {
						document.getElementById("containers").children[0].children[0].appendChild(component.$el)
					} catch(e) {
						document.getElementById("containers").children[0].children[0].appendChild(component.$el)
					}
				}, 10)
			}
		}
	}
</script>

<style scoped>
	.items p {
		height: 40px;
		line-height: 18px;
		padding-left: 10px;
		color: #fff;
	}
	
	.tableList1 {
		margin-top: 10px;
	}
	
	.ret {
		font-size: 22px;
		font-weight: bold;
		color: #75c3ff;
	}
	
	.ret:hover {
		font-size: 22px;
		font-weight: bold;
		color: #297af5;
		cursor: pointer;
	}
	
	#control {
		width: 70%;
		display: flex;
		justify-content: space-between;
	}
	/* .side{
    width:15%;
    height:500px;
    background-color:#08172E;
    color: #ffffff;
    float: left;
    z-index: 666;
  }
  .openspan{
    display: inline-block;
    width:30px;height:30px;
    position: relative;left:0;
    top:258px;
    z-index: 9999
  }
  .closespan{
    display: inline-block;
    width:30px;height:30px;
    position: relative;left:0;
    top:258px;
    z-index: 9999
  } */
	
	.Gogle-maps {
		height: calc(100vh - 122px);
		width: 100%;
		margin-bottom: 15px;
		/*margin-top:10px;*/
		position: relative;
		z-index: revert;
	}
	
	.goole-block {
		height: 102px;
		width: 100%;
		background: rgba(10, 22, 55, 0.5);
		z-index: 3;
		color: #ffffff;
		padding-left: 40px;
		position: absolute;
	}
	
	.goole-block p {
		color: #ffffff;
		font-size: 16px;
		line-height: 35px;
		display: inline-block;
		font-weight: bold;
		/*margin-top: 7px;*/
		margin-left: 5px;
	}
	
	.colseGogle {
		height: calc(100vh - 107px);
		width: 100%;
		float: left;
	}
	
	.allText {
		margin: 15px;
	}
	
	.allSize {
		font-size: 18px;
	}
	
	.textpad {
		margin: 0 10px;
		font-size: 16px;
	}
	
	.details-ret {
		display: inline-block;
		margin-left: 15px;
	}
	
	.details-ret span {
		display: inline-block;
		margin-left: 5px;
		font-size: 14px;
		font-weight: unset;
		color: #f45a2b;
	}
	
	.blue-border-map {
		display: inline-block;
		width: 5px;
		height: 20px;
		position: relative;
		top: 3px;
		background-color: #297af5
	}
	/* .gm-control-active, .gmnoprint{
    z-index: 4 !important;
  } */
</style>


// WEBPACK FOOTER //
// src/components/TableList/TRecordItemDialog.vue